"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConstValidator = void 0;
const ramda_1 = require("ramda");
const validator_1 = require("./validator");
const utils_1 = require("./utils");
class ConstValidator extends validator_1.CommonValidator {
    merge(props) {
        return new ConstValidator({ ...this.props, ...props });
    }
    value(value) {
        return this.merge({ value });
    }
    validateValue = async ({ rootCtx, ctx, options }) => {
        return (0, validator_1.runValidators)({
            rootCtx,
            ctx,
            options,
            validators: [this.validateConst]
        });
    };
    validateConst = async ({ rootCtx, ctx, next }) => {
        const value = await (0, utils_1.evaluateValue)(rootCtx, ctx, this.props.value);
        if (value === undefined || (0, ramda_1.equals)(ctx.value, value)) {
            return next();
        }
        ctx.addError({ const: value });
    };
}
exports.ConstValidator = ConstValidator;
